module.exports = __webpack_public_path__ + "img/icon (17).66ac396d.png";